import React, { useCallback, useState } from "react";
import ApiData from "../../../api/ApiData";
import { BtnPrimaryv4 } from "../../UI/button/BtnPrimaryv4";
export function ProductionCatalogLoader({
  onLoaded,
  autoLoad = false,
  loadedCount = 0,
}) {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    const controller = new AbortController();
    try {
      const result = await ApiData.fetchAllProduction({
        size: 100,
        signal: controller.signal,
        onProgress: ({ loaded, total }) => {
          setProgress({ loaded, total });
        },
      });
      if (result.error === "forbidden") {
        setError("Нет права get_all_production или доступ запрещён.");
        onLoaded?.(null);
        return;
      }
      onLoaded?.(result.rows);
    } catch (e) {
      if (e?.name !== "AbortError") {
        setError("Не удалось загрузить справочник площадок.");
        onLoaded?.(null);
      }
    } finally {
      setLoading(false);
      setProgress(null);
    }
  }, [onLoaded]);

  const autoLoadedRef = React.useRef(false);
  React.useEffect(() => {
    if (autoLoad && loadedCount === 0 && !loading && !autoLoadedRef.current) {
      autoLoadedRef.current = true;
      load();
    }
  }, [autoLoad, loadedCount, load, loading]);

  const total = progress?.total;
  const loaded = progress?.loaded ?? 0;
  const pct =
    total && total > 0 ? Math.min(100, Math.round((loaded / total) * 100)) : 0;

  return (
    <div className="production-audit-catalog-loader">
      <div className="production-audit-catalog-actions">
        <BtnPrimaryv4
          type="button"
          onClick={load}
          disabled={loading}
          text={loading ? "Загрузка…" : "Загрузить все площадки"}
        />
        {loadedCount > 0 ? (
          <span className="production-audit-muted">
            В каталоге: {loadedCount} записей
          </span>
        ) : null}
      </div>
      {loading ? (
        <div className="production-audit-progress" aria-busy="true">
          <div
            className="production-audit-progress-bar"
            style={{ width: `${pct}%` }}
          />
          <span className="production-audit-progress-label">
            {loaded}
            {total ? ` / ${total}` : ""} площадок
          </span>
          <div className="event-totals-skeleton production-audit-skeleton">
            <div className="event-totals-skeleton-chip" />
            <div className="event-totals-skeleton-chip" />
            <div className="event-totals-skeleton-chip" />
          </div>
        </div>
      ) : null}
      {error ? (
        <p className="production-audit-error" role="alert">{error}</p>
      ) : null}
    </div>
  );
}
